import Flickity from './flickity-player';
import 'flickity-imagesloaded';

import { debounce, toArray } from './helpers';
import { trackHeroSlider } from './tracking';

// add resize class while resizing to make equal height per css min-height:100% on .flickity-enabled.flickity-resize ... possible
Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call(this);
  this.element.classList.add('flickity-resize');
};

const HeroSlider = function () {
  let elements = [];
  const instances = new Map();

  function init(elems = '[data-hero-slider],[data-media-slider]') {
    elements = toArray(
      (typeof elems === 'string')
        ? document.querySelectorAll(elems)
        : elems
    );

    window.addEventListener('resize', debounce(() => {
      setTimeout(() => {
        instances.forEach(instance => {
          instance.resize();
        });
      }, 500);
    }, 500));

    elements.forEach(element => {
      let lastSlideIndex = 0;

      element.classList.add('flickity-resize');

      // Flickity-Slider initialisieren
      const flkty = new Flickity(element, {
        prevNextButtons: false,
        imagesLoaded: true,
        wrapAround: true,
        autoPlay: 7000,
        on: {
          ready: function () {
            trackHeroSlider(this);
          },
          change: function () {
            const lastCellVideo = this.cells[lastSlideIndex].element.querySelector('video');
            if (lastCellVideo) {
              lastCellVideo.pause();
            }

            const currentCellVideo = this.selectedElement.querySelector('video');
            if (currentCellVideo) {
              currentCellVideo.play();
            }

            lastSlideIndex = this.selectedIndex;
          }
        }
      });

      instances.set(element, flkty);
    });
  }

  return {
    init,
  };
};

export default HeroSlider();
